<script lang="ts" setup>
import ORates from '~/components/organisms/Rates.vue'

useSeoMeta({
  title: 'Тарифы Magvi для создания инфографики для маркетплейсов',
  description: 'Стоимость онлайн конструктора по разработке инфографики для марткетплейсов magvi.ru.',
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: useRuntimeConfig().public.appUrl + '/pricing',
    },
  ],
})

</script>

<template>
  <ORates />
</template>
